import { defineMessages } from 'react-intl';

export default defineMessages({
  elevatorIntegrationSetSuccessfully: {
    defaultMessage: 'Elevator integration set successfully.',
    description: 'Elevator integration snackbar - set successfully',
    id: 'elevatorIntegrationSet.success',
  },
});
